<!--  -->
<template>
  <div :class="['ansResultBox', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="趣味活动" :bcColor="'#fff'" :zIndex="1000"> </common-title>
    <section class="drawReaultCenter" :style="{ backgroundImage: `url(${BGList[currIndex]})` }">
      <div class="anscontent">
        <div class="quesone">
          <div class="list">
            <div
              class="text-wrapper"
              v-for="(option, index) in questions[currIndex].options"
              :key="index"
              :class="{ selected: questions[currIndex].selected === option.value }"
              @click="selectOption(currIndex, option)"
            >
              <span>{{ option.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="bottombox" v-if="currIndex > 0">
      <div class="lastques" v-if="isClicklastquestion">
        <img @click="prebtnBtn" :src="imgsList[2]" alt="Previous Button" />
        <img @click="checkBtn" :src="imgsList[3]" alt="Check Button" />
      </div>
      <div v-else>
        <img class="prebtn" @click="prebtnBtn" :src="imgsList[1]" alt="Previous Button" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import ShareDraw from './shareDraw.vue';
import { loadMantisChat } from '@/utils/tools';
import { participationApi } from '@/api/archives/index';

export default {
  components: {
    // ShareDraw,
  },
  data() {
    return {
      isClicklastquestion: false,
      clickLock: false,
      chooseType: '',
      currIndex: 0,
      questions: [
        {
          title: '最近一周，你每天平均的睡眠时间是？',
          options: [
            { label: 'A.', text: '调整学习计划，尝试新方法', value: 'A' },
            { label: 'B.', text: '延长每日学习时间，死磕到底', value: 'B' },
            { label: 'C.', text: '暂时搁置，先处理其他科目', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '在备考过程中，你是否经常感到焦虑？',
          options: [
            { label: 'A.', text: '制定每日任务清单', value: 'A' },
            { label: 'B.', text: '在书桌贴「上岸倒计时」', value: 'B' },
            { label: 'C.', text: '仅靠内心信念驱动', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '当面对考研的巨大压力时，你的应对方式通常是：',
          options: [
            { label: 'A.', text: '用思维导图拆解逻辑', value: 'A' },
            { label: 'B.', text: '结合生活案例联想记忆', value: 'B' },
            { label: 'C.', text: '反复背诵直到记住', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '对于考研的最终结果，你的想法是：',
          options: [
            { label: 'A.', text: '2小时后主动切换科目', value: 'A' },
            { label: 'B.', text: '咖啡续命强行坚持', value: 'B' },
            { label: 'C.', text: '直接放弃当天任务', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '最近一个月，你是否经常出现情绪低落、沮丧的情况？',
          options: [
            { label: 'A.', text: '考研相关资讯', value: 'A' },
            { label: 'B.', text: '短视频/社交媒体', value: 'B' },
            { label: 'C.', text: '学习类博主经验贴', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '在学习过程中，如果遇到难题长时间无法解决，你的反应是：',
          options: [
            { label: 'A.', text: '分享自己的解压方法', value: 'A' },
            { label: 'B.', text: '安慰但不深入讨论', value: 'B' },
            { label: 'C.', text: '专注自身不予回应', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '看到周围同学的复习进度比自己快，你会：',
          options: [
            { label: 'A.', text: '太阳：稳定发光，但路径固定', value: 'A' },
            { label: 'B.', text: '火炬：需要持续补给，但能照亮他人', value: 'B' },
            { label: 'C.', text: '流星：爆发力强但不可控', value: 'C' },
          ],
          selected: null,
        },
        {
          title: '对于每天的学习任务，你完成的情况是：',
          options: [
            { label: 'A.', text: '分享自己的解压方法', value: 'A' },
            { label: 'B.', text: '微调方法继续坚持', value: 'B' },
            { label: 'C.', text: '等待外部激励信号', value: 'C' },
          ],
          selected: null,
        },
      ],
      imgsList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/comeon.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/prebtn.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/prebtnmin.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/resultmin.png`,
      ],
      BGList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg1.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg2.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg3.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg4.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg5.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg6.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg7.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/bg8.png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    selectOption(index, option) {
      if (this.clickLock) return; // 如果点击锁定，直接返回
      this.clickLock = true; // 锁定进一步的点击
      if (index >= 0 && index < this.questions.length) {
        const question = this.questions[index];
        if (question) {
          question.selected = option.value;
          if (this.currIndex === this.questions.length - 1) {
            this.isClicklastquestion = true;
          } else if (
            this.currIndex === this.questions.length - 2 &&
            this.questions[this.questions.length - 1].selected
          ) {
            this.isClicklastquestion = true;
          }
          if (index < this.questions.length - 1) {
            setTimeout(() => {
              this.currIndex++;
              this.clickLock = false; // 在延时操作完成后解锁点击
            }, 600);
          }
          if (index == this.questions.length - 1) {
            this.clickLock = false;
          }
        }
      }
    },
    prebtnBtn() {
      this.currIndex--;
      this.isClicklastquestion = false;
      this.clickLock = false;
    },
    async checkBtn() {
      let drawNum = this.calculateDrawNum();
      const res = await participationApi({ type: this.chooseType });
      if (res.code == 0) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/fungameresult?drawNum=${drawNum}&hiddenNavigationBar=1`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        this.$router.replace({
          path: '/fungameresult',
          query: {
            drawNum,
          },
        });
        return;
      } else {
        this.$toast(res.msg);
      }
    },

    calculateDrawNum() {
      // 1.题5选B+题8选A——>棱镜追光者(drawNum=1)；否则进入第二步判断
      if (this.questions[4].selected === 'B' && this.questions[7].selected === 'A') {
        this.chooseType = '棱镜追光者';
        return 1;
      }

      // 2.选A≥4次——>恒星追光者(drawNum=2)；否则进入第三步判断
      let countA = 0;
      this.questions.forEach((question) => {
        if (question.selected === 'A') {
          countA++;
        }
      });
      if (countA >= 4) {
        this.chooseType = '恒星追光者';
        return 2;
      }

      // 3-5.根据题7的选择判断
      const question7Selected = this.questions[6].selected;
      switch (question7Selected) {
        case 'A':
          this.chooseType = '萤火追光者';
          return 3; // 萤火追光者
        case 'B':
          this.chooseType = '火炬追光者';
          return 4; // 火炬追光者
        case 'C':
          this.chooseType = '彗星追光者';
          return 5; // 彗星追光者
        default:
          return 1; // 默认返回棱镜追光者
      }
    },
  },
  created() {
    loadMantisChat(this.userInfo);
    window.onresize = () => {
      this.$refs.progress.resize();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.ansResultBox {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  background-color: #062f68;

  &.inApp {
    padding-top: 0;
  }

  .drawReaultCenter {
    position: relative;
    width: 100%;
    height: 1174px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    .comeon {
      display: block;
      width: 100%;
      height: 144px;
      margin: 0 auto;
    }

    .anscontent {
      position: relative;
      width: 698px;
      height: 800px;
      // background-color: #ffc10761;
      margin: 0 auto;

      .quesone {
        .list {
          position: absolute;
          top: 400px;
          right: 0;
          left: 60px;
          width: 473px;
          margin: 0 auto;

          .text-wrapper {
            position: relative;
            width: 473px;
            margin-bottom: 66px;
            padding: 24px 0 24px 30px;
            color: #fff;
            font-weight: 500;
            font-size: 30px;
            background: #061b4b8f;
            border: 2px solid #77f3ff;
          }

          .selected {
            background-color: #93effa;

            span {
              color: #000;
            }
          }
        }
      }
    }
  }

  .bottombox {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 130px;
    margin: 0 auto;
    background: #fff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 -5px 8px 0 rgba(95, 172, 120, 0.09);

    .prebtn {
      position: fixed;
      right: 0;
      bottom: 50px;
      left: 0;
      display: block;
      width: 628px;
      height: 152px;
      margin: 0 auto;
    }

    .lastques {
      position: fixed;
      right: 0;
      bottom: 50px;
      left: 0;
      display: flex;
      justify-content: center;

      img {
        display: block;
        width: 300px;
        height: 152px;
        margin: 0 15px;
      }
    }
  }
}

::v-deep .van-progress__pivot {
  width: 20px;
  height: 28px;
  font-size: 0;
  background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/pen.png') !important;
  background-size: 100% 100% !important;
  // transform:translate(30%, 50%);
}

::v-deep .van-progress {
  width: 7rem;
}
</style>
